<template>
  <el-select
    :value="localValue"
    :size="size"
    :multiple="multiple"
    :disabled="disabled"
    clearable
    :placeholder="placeholder"
    @change="selected"
  >
    <el-option
      v-for="(statusConfig, statusId) in $companyConfiguration.cardStatuses.getStatuses()"
      :key="statusId"
      :label="statusConfig.showName"
      :value="statusId"
    >
    </el-option>
  </el-select>

</template>

<script>

export default {
  name: "cards-status-select",
  components: {},
  props: {
    value: {},
    size: {type: String, default: '' },
    disabled: {type: Boolean, default: false },
    multiple: {type: Boolean, default: true },
    placeholder: {type: String, default: 'Статус' },
  },

  data() {
    return {
      localValue: this.value,
    }
  },
  beforeMount() {},
  watch: {},
  computed: {},
  methods: {
    selected(value) {
      this.localValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    }
  },

}
</script>

<style scoped>

</style>